import type { SVGProps } from 'react';

/** Figma: Discovery — calendar-check (21125:166108) */
const ReservedParking = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    fill="none"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M10 2.5V7.5M20 2.5V7.5M3.75 12.5H26.25M11.25 20L13.75 22.5L18.75 17.5M6.25 5H23.75C25.1307 5 26.25 6.11929 26.25 7.5V25C26.25 26.3807 25.1307 27.5 23.75 27.5H6.25C4.86929 27.5 3.75 26.3807 3.75 25V7.5C3.75 6.11929 4.86929 5 6.25 5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ReservedParking;
